export enum UserTypes {
  LOGIN_REQUEST = 'userData/User/LOGIN_REQUEST',
  LOGIN_SUCCESS = 'userData/User/LOGIN_SUCCESS',
  LOGIN_FAILURE = 'userData/User/LOGIN_FAILURE',
  UPDATE_LANG_REQUEST = 'userData/User/UPDATE_LANG_REQUEST',
  UPDATE_LANG_SUCCESS = 'userData/User/UPDATE_LANG_SUCCESS',
  UPDATE_LANG_FAILURE = 'userData/User/UPDATE_LANG_FAILURE',
}
